'use strict';

function getKeys(obj) {
  return Object.keys(obj);
}

module.exports = getKeys;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/getKeys.js
// module id = 140
// module chunks = 0